export default function Footer() {
  const links = [
    {
      title: '内容分类',
      items: ['国产剧', '日韩剧', '欧美剧', '动漫', '综艺', '纪录片', '电影', '少儿'],
    },
    {
      title: '平台服务',
      items: ['手机APP', '常见问题', '联系我们', '意见反馈', '用户协议', '隐私政策'],
    },
    {
      title: '关于我们',
      items: ['平台介绍', '加入我们', '媒体合作', '内容投稿', '广告合作'],
    },
  ];

  return (
    <footer id="footer" className="bg-background-950 border-t border-background-200/30">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div>
            <a href="#hero" className="flex items-center gap-2.5 mb-4 no-underline cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-foreground-50 text-xl"></i>
              </div>
              <span className="text-lg font-bold tracking-wide text-foreground-100 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                极速影视
              </span>
            </a>
            <p className="text-xs text-foreground-600 leading-relaxed mb-4">
              极速影视平台主打极速不缓冲高清在线观看体验，流畅播放不卡顿，免费看电视剧全集和最新电影。极速高清不卡秒开即播随心追——全国5000万追剧用户的一致选择。
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500/20 transition-colors cursor-pointer no-underline">
                <i className="ri-wechat-line text-foreground-400 text-sm"></i>
              </a>
              <a href="#contact" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500/20 transition-colors cursor-pointer no-underline">
                <i className="ri-weibo-line text-foreground-400 text-sm"></i>
              </a>
              <a href="#contact" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500/20 transition-colors cursor-pointer no-underline">
                <i className="ri-bilibili-line text-foreground-400 text-sm"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          {links.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-200 mb-3">{col.title}</h4>
              <ul className="space-y-2">
                {col.items.map((item) => (
                  <li key={item}>
                    <a
                      href={item === '手机APP' ? '#app' : item === '常见问题' ? '#faq' : item === '联系我们' || item === '意见反馈' ? '#contact' : item === '平台介绍' ? '#about' : '#hero'}
                      className="text-xs text-foreground-500 hover:text-foreground-200 transition-colors no-underline cursor-pointer whitespace-nowrap"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Partners */}
        <div className="border-t border-background-200/20 pt-8 mb-8">
          <h4 className="text-xs font-semibold text-foreground-400 mb-4">合作伙伴</h4>
          <div className="flex flex-wrap items-center gap-6">
            <span className="text-xs text-foreground-600">内容合作 · 技术联盟 · 广告平台</span>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-background-200/20 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2020-2026 极速影视 jisumovies.tv 版权所有 | 极速不缓冲 · 高清秒播 · 免费看全集
          </p>
          <p className="text-xs text-foreground-700">
            <a href="#hero" className="text-foreground-600 hover:text-foreground-400 transition-colors no-underline cursor-pointer">回到顶部</a>
          </p>
        </div>
      </div>
    </footer>
  );
}